"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelList = void 0;
var mobx_1 = require("mobx");
var ModelContainer_1 = require("./ModelContainer");
var ModelList = /** @class */ (function (_super) {
    __extends(ModelList, _super);
    function ModelList(modelClass) {
        var _this = _super.call(this, modelClass) || this;
        _this.modelClass = modelClass;
        _this._items = mobx_1.observable([]);
        return _this;
    }
    Object.defineProperty(ModelList.prototype, "items", {
        get: function () {
            return this._items.filter(function (item) { return !item.deleted; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ModelList.prototype, "hasError", {
        get: function () {
            return !!this.error;
        },
        enumerable: false,
        configurable: true
    });
    ModelList.prototype.setItems = function (items) {
        this._items.clear();
        this.appendItems(items);
    };
    ModelList.prototype.appendItems = function (items) {
        var _a;
        (_a = this._items).push.apply(_a, items);
    };
    ModelList.prototype.appendItem = function (item) {
        this._items.push(item);
    };
    ModelList.prototype.unshiftItem = function (item) {
        this.setItems(__spreadArrays(this._items.filter(function (i) { return i.id !== item.id; })));
        this._items.unshift(item);
    };
    ModelList.prototype.deserialize = function (items) {
        var _this = this;
        if (!items) {
            this.loaded = true;
            return;
        }
        var models = items.map(function (item) { return _this.modelClass.fromJson(item); });
        this.setItems(models);
        this.loaded = true;
    };
    ModelList.prototype.clearItems = function () {
        this._items.clear();
        this.setLoaded(false);
    };
    __decorate([
        mobx_1.observable
    ], ModelList.prototype, "_items", void 0);
    __decorate([
        mobx_1.computed
    ], ModelList.prototype, "items", null);
    __decorate([
        mobx_1.computed
    ], ModelList.prototype, "hasError", null);
    __decorate([
        mobx_1.action
    ], ModelList.prototype, "setItems", null);
    __decorate([
        mobx_1.action
    ], ModelList.prototype, "appendItems", null);
    __decorate([
        mobx_1.action
    ], ModelList.prototype, "appendItem", null);
    __decorate([
        mobx_1.action
    ], ModelList.prototype, "unshiftItem", null);
    __decorate([
        mobx_1.action
    ], ModelList.prototype, "deserialize", null);
    __decorate([
        mobx_1.action
    ], ModelList.prototype, "clearItems", null);
    return ModelList;
}(ModelContainer_1.ModelContainer));
exports.ModelList = ModelList;
